import { TableCell } from '@mui/material';
import { OrderButton } from 'components/OrderButton';
import { useTranslation } from 'react-i18next';
import { OrderByDirection } from 'types/types';

interface TableHeaderCellProps {
  orderBy: string;
  orderByDirection: OrderByDirection;
  onOrderByClick: (orderBy: string) => void;
  onDirectionClick: () => void;
  name: string;
  align?: 'left' | 'center' | 'right';
  'data-testid'?: string;
}

export const TableHeaderCell = ({
  orderBy,
  orderByDirection,
  onOrderByClick,
  onDirectionClick,
  name,
  align,
  'data-testid': dataTestId,
}: TableHeaderCellProps) => {
  const { t } = useTranslation();
  const isOrderBy = orderBy === name;

  return (
    <TableCell
      data-testid={dataTestId}
      sx={{ fontWeight: 'bold' }}
      onClick={() => {
        onOrderByClick(name);
      }}
      align={align}
    >
      {t(`general.${name}`)}
      {isOrderBy && (
        <OrderButton
          orderDirection={orderByDirection}
          orderBy={orderBy}
          onClick={() => {
            onDirectionClick();
          }}
        />
      )}
    </TableCell>
  );
};
